"use client";
import { useBreakpointValue, type RecipeVariantProps } from "@chakra-ui/react";
import { textRecipe } from "@/theme/recipes/text.recipe";
import { headingRecipe } from "../recipes/heading.recipe";

type TextVariant = RecipeVariantProps<typeof textRecipe>["variant"];
type HeadingVariant = RecipeVariantProps<typeof headingRecipe>["variant"];

export const useHeadingVariant = (): HeadingVariant => {
  return useBreakpointValue({
    base: "headLine3",
    md: "headLine2",
  });
};

export const useTextVariant = (): TextVariant => {
  return useBreakpointValue({
    base: "body3",
    md: "body2",
  });
};
